import moment from 'moment';
import * as actions from './ReportFiltersActionsType';
import {SUMMARY_REPORT} from '../ReportTypes';


const FILTERS_KEY = 'reportsFilters';

export const initialState = {
  applied: {
    chips: [],
    terminals: [],
    startTime: moment().subtract(180, 'days').startOf('day').valueOf(),
    endTime: moment().subtract(1, 'days').endOf('day').valueOf(),
    reportSelected: SUMMARY_REPORT.key
  },
  terminals: {
    loading: false,
    entries: []
  },
  chipsOptions: {
    loading: false,
    entries: []
  }
};


const saveFilter = ({applied}) => {
  localStorage.setItem(FILTERS_KEY, JSON.stringify({applied}));
};

const initializeState = () => {
  const savedFilters = localStorage.getItem(FILTERS_KEY);
  if (savedFilters) {
    try {
      const parsed = JSON.parse(savedFilters);
      return {
        ...initialState,
        ...parsed
      };
    } catch (ex) {
      console.error(ex);
    }
  }

  return initialState;
};

const handleState = (state, action) => {
  const {type} = action;
  switch (type) {
    case actions.SEARCH_REQUEST:
      return {...state, chipsOptions: {...state.chipsOptions, loading: true}};
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        chipsOptions: {...state.chipsOptions, loading: false, entries: action.payload}
      };
    case actions.SEARCH_FAILURE:
      return {...state, chipsOptions: {...state.chipsOptions, loading: false}};
    case actions.SEARCH_CLEAR:
      return {...state, chipsOptions: initialState.chipsOptions};
    case actions.TERMINALS_REQUEST:
      return {...state, terminals: {...state.terminals, loading: true}};
    case actions.TERMINALS_SUCCESS:
      return {...state, terminals: {...state.terminals, loading: false, entries: action.payload}};
    case actions.TERMINALS_FAILURE:
      return {...state, terminals: {...state.terminals, loading: false}};
    case actions.SET_CHIP:
      return {...state, applied: {...state.applied, chips: action.payload}};
    case actions.SET_REPORT:
      return {...state, applied: {...state.applied, reportSelected: action.payload}};
    case actions.SET_DATE:
      return {...state, applied: {...state.applied, startTime: action.payload.startTime, endTime: action.payload.endTime}};
    case actions.SET_TERMINALS:
      return {...state, applied: {...state.applied, terminals: action.payload}};
    case actions.CLEAR_HIDEABLE:
      return {
        ...state,
        applied: {
          ...state.applied,
          terminals: initialState.applied.terminals
        }
      };
    case actions.CLEAR:
      return {...state, ...initialState, applied: {...state.applied}};
    default:
      return state;
  }
}

export default (state = initializeState(), action = {}) => {
  const newState = handleState(state, action);
  saveFilter(newState);
  return newState;
};
